import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';


// react-slickのスタイルをインポート
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import { App } from './App';
import Head from './Head';
import './resets.css';
import './assets/styles/main.scss';


createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Head title="HADO EDUCATION 教育の様々なシーンで活用" description="AR技術を駆使した体験提供で課題解決のお手伝いをします。性別、年齢差、体格差、運動能力差が出にくいため世界中で子どもたちの自立する“心”を育む取り組みとして採用されています" />
    <App />
  </StrictMode>,
  
);

